"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var deepCloneObject = function cloneObject(objectToClone) {
  var clone = {};
  var keys = Object.keys(objectToClone);

  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];
    var isObject = objectToClone[key] !== null && (0, _typeof2["default"])(objectToClone[key]) === 'object' && !Array.isArray(objectToClone[key]);

    if (isObject) {
      clone[key] = cloneObject(objectToClone[key]);
    } else {
      clone[key] = objectToClone[key];
    }
  }

  return clone;
};

var _default = deepCloneObject;
exports["default"] = _default;